import { Field } from 'formik';
import React from 'react';
import PropTypes from 'prop-types';
import { Label } from 'reactstrap';

const FieldItem = (props) => {
   return (
      <Label
         className='d-block'
      >
         { props.label }
         <Field
            {
               ...props
            }
         />
      </Label>
   );
};

FieldItem.propTypes = {
   label: PropTypes.string.isRequired,
   name: PropTypes.string.isRequired,
   component: PropTypes.func.isRequired,
   options: PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
   })),
};

FieldItem.defaultProps = {
   options: undefined,
};


export default FieldItem;
